import React from 'react';
import PropTypes from 'prop-types';
import ReactDropzone from 'react-dropzone';
import { gettext } from '../utils/text';
import Loading from './Loading';

class UploadBox extends React.Component {
    static propTypes = {
        name: PropTypes.string,
        accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        multiple: PropTypes.bool,
        filesAreBeingUploaded: PropTypes.bool,
        onDrop: PropTypes.func.isRequired,
        height: PropTypes.string,
        width: PropTypes.string,
    };

    static defaultProps = {
        name: '',
        accept: undefined,
        multiple: true,
        filesAreBeingUploaded: false,
        height: '15rem',
        width: '100%',
    };

    render() {
        let message = '';
        if (this.props.multiple) {
            message = gettext('Click here or drop your files to upload');
        } else {
            message = gettext('Click here or drop your file to upload');
        }
        return (
            <ReactDropzone
                name={this.props.name}
                accept={this.props.accept}
                multiple={this.props.multiple}
                onDrop={(...args) => this.props.onDrop(...args)}
                style={{
                    height: this.props.height,
                    width: this.props.width,
                    border: '1px dashed #1D1D1D',
                }}
            >
                <div className="subtitle h-100 d-flex align-items-center justify-content-center text-center">
                    <i className="icon icon--folder--download mr-3" />
                    {message}
                    {this.props.filesAreBeingUploaded && (
                        <div className="position-absolute mt-5">
                            <Loading />
                        </div>
                    )}
                </div>
            </ReactDropzone>
        );
    }
}

export default UploadBox;



// WEBPACK FOOTER //
// ./src/components/UploadBox.js